import { observer } from 'mobx-react';
import React from 'react';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { ModuleType } from '../../constants/enums/module-type-enum';
import {
  findRouteAccess,
  redirectToDefaultRoute,
} from '../../helpers/route-helper';
import {
  AccountActivation,
  ActiveTrayManagement,
  AIMSPortal,
  BaseUser,
  FactoryAccess,
  FactoryManagement,
  FactorySchedule,
  GroupManagement,
  HKRDashboardData,
  KishuManagement,
  Login,
  OperatorAssignTask,
  OrderTableView,
  ProcessManagement,
  ProcessTemplateManagement,
  ProductManagement,
  TagAssignRemove,
  TeplarPrint,
  TrayManagement,
  UserLogs,
  DimensionTableFields,
  CheckItemTemplate,
  TrayTagReassignment,
  BomSearch,
  ToolManagement,
  ToolCheckItemTemplate,
  DefectiveItems,
  CrimpingInspectionRecord,
  UserCreatedInspectionRecord,
  EquipmentManagement,
  EquipmentInspectionMenu,
  ToolBOM,
} from '../../modules';
import ProcessWiseChart from '../../modules/active-tray-mgmt/process-wise-chart';
import OperatorListDetail from '../../modules/operator/OperatorListDetail';
import OperatorTagAssign from '../../modules/operator/operatorTagAssign';
import CrimpToolInspection from '../../modules/tool-management/inspection/crimp-tool-inspection';
import UserCreatedInspection from '../../modules/tool-management/inspection/user-created-inspection';
import LayoutRoute from '../layout/layout-route';
import LoginLayoutRoute from '../layout/login-layout-route';
import RoutesConstants from './routes-constants';
import MaterialTagAssign from '../../modules/bom-search/components/material-tag-assign';
import PartsSearch from '../../modules/bom-search/components/parts-search';
import Nonconformity from '../../modules/nonconformity/nonconformity';
import NonConformanceReport from '../../modules/nonconformity-report/non-conformance-report';

const Routes = () => {
  return (
    <React.Fragment>
      <Switch>
        <LoginLayoutRoute
          path={RoutesConstants.Login}
          component={Login}
        />
        <LayoutRoute
          path={RoutesConstants.AccountActivation}
          component={AccountActivation}
        />
        {findRouteAccess(ModuleType.UserManagement) && (
          <LayoutRoute
            path={RoutesConstants.UserManagement}
            component={BaseUser}
          />
        )}
        {findRouteAccess(ModuleType.TenantManagement) && (
          <LayoutRoute
            path={RoutesConstants.FactoryManagement}
            component={FactoryManagement}
          />
        )}
        {findRouteAccess(ModuleType.AIMSPortal) && (
          <LayoutRoute
            path={RoutesConstants.AIMSPortal}
            component={AIMSPortal}
          />
        )}
        {findRouteAccess(ModuleType.HolidayCalendar) && (
          <LayoutRoute
            path={RoutesConstants.HolidayCalendar}
            component={FactorySchedule}
          />
        )}
        {findRouteAccess(ModuleType.ProcessManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProcessManagement}
            component={ProcessManagement}
          />
        )}
        {findRouteAccess(ModuleType.ProcessTemplateManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProcessTemplateManagement}
            component={ProcessTemplateManagement}
          />
        )}
        {findRouteAccess(ModuleType.ProductManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProductManagement}
            component={ProductManagement}
          />
        )}
        {findRouteAccess(ModuleType.OperatorMenu) && (
          <LayoutRoute
            path={RoutesConstants.Nonconformity}
            component={Nonconformity}
          />
        )}
        {findRouteAccess(ModuleType.OperatorMenu) && (
          <LayoutRoute
            path={RoutesConstants.NonconformityReport}
            component={NonConformanceReport}
          />
        )}
        {findRouteAccess(ModuleType.TeplarPrintTemplateManagement) && (
          <LayoutRoute
            path={RoutesConstants.TeplarPrintTemplateManagement}
            component={TeplarPrint}
          />
        )}
        {findRouteAccess(ModuleType.TrayManagement) && (
          <LayoutRoute
            path={RoutesConstants.TrayManagement}
            component={TrayManagement}
          />
        )}
        {findRouteAccess(ModuleType.GroupManagement) && (
          <LayoutRoute
            path={RoutesConstants.GroupManagement}
            component={GroupManagement}
          />
        )}
        {findRouteAccess(ModuleType.ActiveTrayManagement) && (
          <LayoutRoute
            path={RoutesConstants.ActiveTrayManagement}
            component={ActiveTrayManagement}
          />
        )}
        {findRouteAccess(ModuleType.ActiveTrayManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProcessWiseChart}
            component={ProcessWiseChart}
          />
        )}
        {findRouteAccess(ModuleType.OrderViewDashboard) && (
          <LayoutRoute
            path={RoutesConstants.OrderTableView}
            component={OrderTableView}
          />
        )}
        {findRouteAccess(ModuleType.OrderViewDashboard) && (
          <LayoutRoute
            path={RoutesConstants.HKRDashboarData}
            component={HKRDashboardData}
          />
        )}
        {findRouteAccess(ModuleType.KishuManagement) && (
          <LayoutRoute
            path={RoutesConstants.KishuManagement}
            component={KishuManagement}
          />
        )}
        {findRouteAccess(ModuleType.BomSearch) && (
          <LayoutRoute
            path={RoutesConstants.BomSearch}
            component={BomSearch}
          />
        )}
        {findRouteAccess(ModuleType.BomSearch) && (
          <LayoutRoute
            path={RoutesConstants.MaterialTagAssign}
            component={MaterialTagAssign}
          />
        )}
        {findRouteAccess(ModuleType.BomSearch) && (
          <LayoutRoute
            path={RoutesConstants.PartsSearch}
            component={PartsSearch}
          />
        )}

        <LayoutRoute
          path={RoutesConstants.OperatorListDetail}
          component={OperatorListDetail}
        />

        <LayoutRoute
          path={`${RoutesConstants.OperatorAssignTask}/:taskId`}
          component={OperatorAssignTask}
        />
        {/* Start - Only for testing purpose */}
        <LayoutRoute
          path={`${RoutesConstants.OperatorAssignSpecialTask1}/:taskId`}
          component={OperatorTagAssign}
        />
        {/* End - Only for testing purpose */}

        <LayoutRoute
          path={`${RoutesConstants.OperatorAssignSpecialTask}/:taskId`}
          component={TagAssignRemove}
        />

        <LayoutRoute
          path={RoutesConstants.OperatorTagAssign}
          component={OperatorTagAssign}
        />
        {findRouteAccess(ModuleType.FactoryAccess) && (
          <LayoutRoute
            path={RoutesConstants.FactoryAccess}
            component={FactoryAccess}
          />
        )}

        <LayoutRoute
          path={RoutesConstants.UserLogs}
          component={UserLogs}
        />
        <LayoutRoute
          path={RoutesConstants.DimensionTableFields}
          component={DimensionTableFields}
        />
        {findRouteAccess(ModuleType.CheckItemTemplate) && (
          <LayoutRoute
            path={RoutesConstants.CheckItemTemplate}
            component={CheckItemTemplate}
          />
        )}
        {findRouteAccess(ModuleType.TrayTagReassignment) && (
          <LayoutRoute
            path={RoutesConstants.TrayTagReassignment}
            component={TrayTagReassignment}
          />
        )}
        {/* {findRouteAccess(ModuleType.ToolManagement) && ( */}
        {true && (
          <LayoutRoute
            path={RoutesConstants.CrimpToolInspection}
            component={CrimpToolInspection}
          />
        )}
        {/* {findRouteAccess(ModuleType.ToolManagement) && ( */}
        {true && (
          <LayoutRoute
            path={RoutesConstants.UserCreatedInspection}
            component={UserCreatedInspection}
          />
        )}
        {/* {findRouteAccess(ModuleType.ToolManagement) && ( */}
        {true && (
          <LayoutRoute
            path={RoutesConstants.ToolManagement}
            component={ToolManagement}
          />
        )}
        {/* {findRouteAccess(ModuleType.ToolCheckItemTemplate) && ( */}
        {true && (
          <LayoutRoute
            path={RoutesConstants.ToolCheckItemTemplate}
            component={ToolCheckItemTemplate}
          />
        )}
        {/* {findRouteAccess(ModuleType.ToolBOM) && ( */}
        {true && (
          <LayoutRoute
            path={RoutesConstants.ToolBOM}
            component={ToolBOM}
          />
        )}
        {/* {findRouteAccess(ModuleType.DefectiveItems) && ( */}
        {true && (
          <LayoutRoute
            path={RoutesConstants.DefectiveItems}
            component={DefectiveItems}
          />
        )}
        {/* {findRouteAccess(ModuleType.CrimpingInspectionRecord) && ( */}
        {true && (
          <LayoutRoute
            path={RoutesConstants.CrimpingInspectionRecord}
            component={CrimpingInspectionRecord}
          />
        )}
        {/* {findRouteAccess(ModuleType.UserCreatedInspectionRecord) && ( */}
        {true && (
          <LayoutRoute
            path={RoutesConstants.UserCreatedInspectionRecord}
            component={UserCreatedInspectionRecord}
          />
        )}
        {true && (
          <LayoutRoute
            path={RoutesConstants.EquipmentManagement}
            component={EquipmentManagement}
          />
        )}
        {true && (
          <LayoutRoute
            path={RoutesConstants.EquipmentInspectionMenu}
            component={EquipmentInspectionMenu}
          />
        )}

        <Redirect to={redirectToDefaultRoute()} />
      </Switch>
    </React.Fragment>
  );
};

export default withRouter(observer(Routes));
